import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Sparkles } from "lucide-react";

export default function DirectLogin() {
  const { setUser, setChild } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    // Directly set Aavyaa's profile
    setUser({
      id: "2cd843b6-e5e6-49d5-a83d-44e5abc8fa4c",
      phone: "7003705584",
    });
    setChild({
      id: "a5143548-28b7-4270-a8bf-f397a2db91cb",
      name: "Aavyaa",
      conditions: ["Down syndrome"],
      clips_ingested: true,
      observation_points: [
        "How interested is the child while playing?",
        "How is the child's balance while walking, sitting, and standing?",
        "Is the child attempting fine motor activities like puzzles, blocks, object placement?",
        "How cheerful and responsive does the child seem?",
        "Does the child follow simple instructions or ignore them?",
        "How cooperative is the child during meals?",
        "Is the child wearing glasses consistently, if prescribed?",
        "How many times does the child remove or throw glasses?",
        "Does the child seem more engaged during one-to-one interaction versus passive time?",
        "Does the child throw away stuff a lot?",
        "Does the child get violent at any point of time?",
        "How much time did the child spend eating?",
        "Is the caregiver giving enough attention?",
        "Is the caregiver behaving gently and patiently?",
        "Is the caregiver spending too much time on the phone?",
        "Is the caregiver actively engaging the child or only supervising passively?",
      ],
      custom_observations: [],
    });
    navigate("/app", { replace: true });
  }, [setUser, setChild, navigate]);

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex flex-col items-center justify-center">
      <Sparkles size={24} className="text-[#D4A373] animate-pulse" />
      <p className="font-outfit text-lg text-[#2F3630] mt-3">Loading Aavyaa's profile...</p>
    </div>
  );
}
